import {
  ADD_CLUB_SUBSCRIPTION_SHIPMENT_ITEM_REQUEST,
  EXCHANGE_CLUB_SUBSCRIPTION_SHIPMENT_ITEM_REQUEST,
  EDIT_CLUB_SUBSCRIPTION_SHIPMENT_ITEM_REQUEST,
  DELETE_CLUB_SUBSCRIPTION_SHIPMENT_ITEM_REQUEST,
  PROCESS_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST,
  SKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST,
  UNSKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST
} from './constants';

export const addItemToShipment = (
  clubSubscriptionShipmentId,
  item,
  successFunction,
  errorFunction
) => ({
  type: ADD_CLUB_SUBSCRIPTION_SHIPMENT_ITEM_REQUEST,
  clubSubscriptionShipmentId,
  item,
  successFunction,
  errorFunction
});

export const exchangeItemOnShipment = (
  clubSubscriptionShipmentId,
  productVariantId,
  item,
  successFunction,
  errorFunction
) => ({
  type: EXCHANGE_CLUB_SUBSCRIPTION_SHIPMENT_ITEM_REQUEST,
  clubSubscriptionShipmentId,
  productVariantId,
  item,
  successFunction,
  errorFunction
});

export const editItemOnShipment = (
  clubSubscriptionShipmentId,
  productVariantId,
  item,
  successFunction,
  errorFunction
) => ({
  type: EDIT_CLUB_SUBSCRIPTION_SHIPMENT_ITEM_REQUEST,
  clubSubscriptionShipmentId,
  productVariantId,
  item,
  successFunction,
  errorFunction
});

export const removeItemFromShipment = (
  clubSubscriptionShipmentId,
  productVariantId,
  successFunction,
  errorFunction
) => ({
  type: DELETE_CLUB_SUBSCRIPTION_SHIPMENT_ITEM_REQUEST,
  clubSubscriptionShipmentId,
  productVariantId,
  successFunction,
  errorFunction
});

export const processShipment = (
  clubSubscriptionShipmentId,
  successFunction
) => ({
  type: PROCESS_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST,
  clubSubscriptionShipmentId,
  successFunction
});

export const skipShipment = (clubSubscriptionShipmentId, successFunction) => ({
  type: SKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST,
  clubSubscriptionShipmentId,
  successFunction
});

export const unskipShipment = (
  clubSubscriptionShipmentId,
  successFunction
) => ({
  type: UNSKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST,
  clubSubscriptionShipmentId,
  successFunction
});
